const ErrorMessages = {
  "auth/email-already-in-use":
    "The email address you entered is already in use. Please use a different email address or sign in to your existing account.",
  "auth/invalid-email":
    "The email address you entered is not valid. Please enter a valid email address.",
  "auth/user-not-found":
    "No account was found for the email address you entered. Please check the email address and try again.",
  "auth/wrong-password":
    "The password you entered is incorrect. Please check the password and try again.",
  "auth/missing-email": "Please provide a valid email address.",
  default:
    "Sorry, there was a problem processing your request. Please try again later.",
};

export default ErrorMessages;
